import React from 'react';
import { connect } from 'react-redux';
import Ax from '../../../components/hoc/Ax';
import Loader from '../../../components/ui/Loader/Loader';
import HttpAPICall from '../../../services/HttpAPICall';
import TapApiUrls, { INVENTORY_API_BASE_URL_2 } from '../../../services/TapApiUrls';
import Status from '../../../components/ui/Status';
import TapIcon from '../../../services/TapIcon';
import { toast } from 'react-toastify';

import ItemDetailsModal from '../../items/itemDetails/ItemDetailsModal';
import { Modal } from 'bootstrap';
import AppBaseComponent from '../../../components/AppBaseComponent';
import CurrencyFormatter from '../../../services/CurrencyFormatter';
import { Link } from 'react-router-dom'
import TicketDetailModal from '../../transactions/ticketTransaction/TicketDetailModal';
import ItemViewInList from '../../inventory/includes/ItemViewInList';
import ItemDemandDetail from '../../inventory/itemDemand/ItemDemandDetail';
import DateService from '../../../services/DateService';

class SalesAllocationDetail extends AppBaseComponent {

    constructor(props) {
        super(props);
        this.state = {
            allocationViewData: null,
            view_loading: false,
            itemDetails: null,
            demandId: ''
        };

        this.itemDetailsRef = React.createRef();
        this.ticketDetailRef = React.createRef();
        this.detailUrl = INVENTORY_API_BASE_URL_2 + '/sales_allocation/detail/'
    }

    componentDidMount() {
        if (this.props && this.props.allocationId) {
            this.getAllocationViewDetails(this.props.allocationId)
        }
        if (this.props && this.props.allocationData) {
            this.setState({ allocationViewData: this.props.allocationData })
        }
        this.viewDemandModal = new Modal(document.getElementById('viewDemandModal'), { keyboard: false, backdrop: false });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.allocationId !== this.props.allocationId) {
            this.getAllocationViewDetails(nextProps.allocationId)
        }
        if (nextProps.allocationData !== this.props.allocationData) {
            this.setState({ allocationViewData: nextProps.allocationData })
        }
    }


    getAllocationViewDetails = (transaction_id) => {
        this.setState({ view_loading: true })
        HttpAPICall.withAthorization('GET', this.detailUrl + transaction_id, this.props.access_token, {}, {}, (resp) => {
            let respData = resp.data;
            this.setState({
                allocationViewData: respData,
                allocationLoaded: false,
            });
        }).then(() => this.setState({ view_loading: false }));
    }


    viewItemModalInit = (item) => {
        if (item) {
            this.itemDetailsRef.current.modalInit(item)
        }
    }

    getTicketDetail = (id) => {
        this.ticketDetailRef.current.ticketModalInit(id)
    }

    formatAddress(address) {
        return <>
            {address.address1 ? address.address1 + ", " : ""}  {address.address2 ? address.address2 + ", " : ""}
            {address.landmark ? address.landmark + ", " : ""} {address.city ? address.city + ". " : ""}<br />
            Location : <b>{address.state_name ? address.state_name + ", " : ""}  {address.district_name ? address.district_name + "& " : ""}  {address.pincode ? address.pincode + "." : ""} <br /></b>
            GSTIN   :   <b>{address.gstin ? address.gstin : "-"}</b>
        </>
    }

    viewDemandModalInit = (id) => {
        if (id) {
            this.setState({
                demandId: id
            }, () => {
                setTimeout(() => this.viewDemandModal.show(), 1000)
            })
        }

    }

    demandDetailsModalJsx = () => {
        return (
            <div className="modal fade" id="viewDemandModal" tabIndex="-1">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="searchItemModalLabel">Item Demand Detail </h5>
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="tab_content_header">
                                {this.state.demandId && <ItemDemandDetail demandId={this.state.demandId} />}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    getGroupedAllocationItems = (items = []) => {
        if (!items || items.length === 0) {
            return [];
        }

        const grouped = {};

        items.forEach((item, idx) => {
            const groupKey = item.item_id || item.item_profile?.id || `line_${item.id || idx}`;

            if (!grouped[groupKey]) {
                grouped[groupKey] = {
                    ...item,
                    qty: 0,
                    invoiced_qty: 0,
                    release_qty: 0,
                    pending_qty: 0,
                    lineItemIds: [],
                    selected_batch_list: [],
                    batchInfoList: [],
                    remarks: []
                };
            }

            grouped[groupKey].qty = parseFloat(grouped[groupKey].qty || 0) + parseFloat(item.qty || 0);
            grouped[groupKey].invoiced_qty = parseFloat(grouped[groupKey].invoiced_qty || 0) + parseFloat(item.invoiced_qty || 0);
            grouped[groupKey].release_qty = parseFloat(grouped[groupKey].release_qty || 0) + parseFloat(item.release_qty || 0);
            grouped[groupKey].pending_qty = parseFloat(grouped[groupKey].pending_qty || 0) + parseFloat(item.pending_qty || 0);

            if (item.id) {
                grouped[groupKey].lineItemIds.push(item.id);
            }

            if (item.remark) {
                grouped[groupKey].remarks.push(item.remark);
            }

            if (item.selected_batch_list && item.selected_batch_list.length > 0) {
                const normalizedSelectedBatchList = item.selected_batch_list.map((batch) => ({
                    batch_number: batch.batch_number || null,
                    expiry_date_display: batch.expiry_date_display || batch.expiry_date || null,
                    qty: batch.qty
                }));

                grouped[groupKey].selected_batch_list = [
                    ...grouped[groupKey].selected_batch_list,
                    ...normalizedSelectedBatchList
                ];
            }

            if (item.batch_number || item.expiry_date_display || item.expiry_date) {
                grouped[groupKey].batchInfoList.push({
                    batch_number: item.batch_number || null,
                    expiry_date_display: item.expiry_date_display || item.expiry_date || null,
                    qty: item.qty
                });
            }
        });

        return Object.values(grouped).map((row) => {
            const mergedBatchList = row.selected_batch_list && row.selected_batch_list.length > 0
                ? row.selected_batch_list
                : row.batchInfoList;

            const uniqueBatchMap = {};
            mergedBatchList.forEach((batch) => {
                const batchNumber = batch.batch_number || null;
                const expiryDate = batch.expiry_date_display || batch.expiry_date || null;
                const batchKey = `${batchNumber}__${expiryDate}`;
                const parsedQty = Number(batch.qty);
                const hasQty = batch.qty !== undefined && batch.qty !== null && batch.qty !== '' && !Number.isNaN(parsedQty);

                if (!uniqueBatchMap[batchKey]) {
                    uniqueBatchMap[batchKey] = {
                        batch_number: batchNumber,
                        expiry_date_display: expiryDate,
                        qty: 0,
                        count: 0
                    };
                }

                if (hasQty) {
                    uniqueBatchMap[batchKey].qty += parsedQty;
                } else {
                    uniqueBatchMap[batchKey].count += 1;
                }
            });

            return {
                ...row,
                remark: row.remarks && row.remarks.length > 0 ? [...new Set(row.remarks)].join(' | ') : row.remark,
                selected_batch_list: Object.values(uniqueBatchMap)
            };
        });
    }

    getBatchLineQty = (batch) => {
        const totalQty = Number(batch.qty || 0);
        const fallbackCount = Number(batch.count || 0);
        const finalQty = totalQty > 0 ? totalQty : fallbackCount;
        return Number.isInteger(finalQty) ? finalQty : parseFloat(finalQty.toFixed(2));
    }

    renderBatchLine = (batch, idx) => {
        const batchNumber = batch.batch_number;
        const expiryDate = batch.expiry_date_display || batch.expiry_date;
        const qty = this.getBatchLineQty(batch);

        return (
            <div key={idx} className='my-1'>
                {batchNumber && expiryDate
                    ? <span>{batchNumber} & {expiryDate} : </span>
                    : batchNumber && !expiryDate
                        ? <span>{batchNumber} : </span>
                        : !batchNumber && expiryDate
                            ? <span>{expiryDate} : </span>
                            : <span>BNA <sup>#</sup> : </span>}
                <b>{qty}</b>
            </div>
        );
    }

    onGroupedItemCheckboxChange = (groupKey, checked) => {
        const groupedCheckboxes = document.querySelectorAll(`[data-group-key="${groupKey}"]`);
        if (groupedCheckboxes && groupedCheckboxes.length > 0) {
            groupedCheckboxes.forEach((checkbox) => {
                checkbox.checked = checked;
            });
        }
    }

    allocationForData = (item) => {
        let type = '';
        let name = '';
        if (!item) { return { type, name }; }

        if (item.sa_for == 'asset') {
            type = 'Asset';
            name = `${item.asset_profile?.name || item.asset?.name || ''} ${item.asset_profile?.asset_code || item.asset?.asset_code ? `(${item.asset_profile?.asset_code || item.asset?.asset_code})` : ''}`.trim();
        } else if (item.sa_for == 'workstation') {
            type = 'Workstation';
            name = item.workstation?.workstation_name || item.workstation?.name || '';
        } else if (item.sa_for == 'sub_assembly') {
            type = 'Sub Assembly';
            name = item.sub_assembly?.name || '';
        } else if (item.sa_for == 'employee') {
            type = 'Employee';
            name = item.employee?.display_full_name || item.employee?.name || '';
        }
        return { type, name };
    }

    render() {
        let allocationData = this.state.allocationViewData
        const groupedAllocationItems = this.getGroupedAllocationItems(allocationData?.items || []);
        return (<Ax>
            {this.state.view_loading ? <Loader />
                : allocationData ?
                    <Ax>
                        <table className="table table-bordered bg-white">
                            <thead className="table-secondary">
                                <tr>
                                    <th style={{ width: "33%" }}>ID</th>
                                    <th style={{ width: "33%" }}>Date</th>
                                    <th style={{ width: "33%" }}>Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td scope="col">{allocationData.transaction_id ? allocationData.transaction_id : "-"}</td>
                                    <td scope="col">
                                        {DateService.dateTimeFormat(allocationData?.transaction_date || "", 'DD-MMM-YYYY')}
                                    </td>
                                    <td scope="col" className="align-middle"> {allocationData.status ? allocationData.status.name : "-"} </td>
                                </tr>
                            </tbody>
                        </table>

                        <div className="tab_content_wrapper" >
                            <span className="content_heading">Sales Allocation Detail</span>
                        </div>
                        <table className="table table-hover table-bordered  table-responsive bg-white my-2 ">
                            <tbody>
                                <tr>
                                    <td style={{ width: "33%" }} >Warehouse</td>
                                    <td colSpan={2}>{allocationData.warehouse ? <div><b>{allocationData.warehouse.name} ({allocationData.warehouse.code})</b>
                                        <br />
                                    </div> : "-"}
                                        <br />
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ width: "33%" }} >Customer</td>
                                    <td colSpan={2} >{allocationData.customer ? <div>{allocationData.customer.name} ({allocationData.customer.code}) <br />
                                       {(allocationData.customerAddress || allocationData.customerProject) &&
                                        <div className='py-1'>
                                            Project : {allocationData.customerProject ? <span><b>{allocationData.customerProject.project_name} ({allocationData.customerProject.project_code}) </b></span> : "-"} <br/>
                                            Address :  {allocationData.customerProject ? this.formatAddress(allocationData.customerProject) : this.formatAddress(allocationData.customerAddress)} </div> }
                                        
                                        </div> : "-"}
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ width: "33%" }}>Deal</td>
                                    <td colSpan={2} >{allocationData.deal_data ? allocationData.deal_data.header : "-"}</td>
                                </tr>
                                <tr>
                                    <td style={{ width: "33%" }}>Sales Order</td>
                                    <td colSpan={2} >{allocationData.sales_order ? allocationData.sales_order.sales_order_type_name : (allocationData.so_transaction_ids && allocationData.so_transaction_ids.length > 0 ? allocationData.so_transaction_ids.join(', ') : "-")}</td>
                                </tr>
                                <tr>
                                    <td style={{ width: "33%" }}>Sales Allocation For</td>
                                    <td colSpan={2}>{this.allocationForData(allocationData).type || "-"}</td>
                                </tr>
                                {allocationData.sa_for ? <tr>
                                    <td style={{ width: "33%" }}>{this.allocationForData(allocationData).type || 'Selection'}</td>
                                    <td colSpan={2}>{this.allocationForData(allocationData).name || "-"}</td>
                                </tr> : null}
                                <tr>
                                    <td style={{ width: "33%" }} >Voucher Number & Date</td>
                                    <td style={{ width: "33%" }} >{allocationData.voucher_number ? allocationData.voucher_number : "-"}</td>
                                    <td style={{ width: "34%" }} >{allocationData.voucher_date ? allocationData.voucher_date : "-"}</td>
                                </tr>
                                <tr>
                                    <td scope="col">Priority & Delivery Date</td>
                                    <td className="text-capitalize">{allocationData.priority ?? "-"}</td>
                                    <td>{allocationData.delivery_date ? DateService.dateTimeFormat(allocationData.delivery_date, 'DD-MMM-YYYY') : "-"}</td>
                                </tr>
                            </tbody>
                        </table>

                        <div className="tab_content_wrapper" >
                            <span className="content_heading">Item Detail</span>
                        </div>
                        {allocationData.additional_attribute_data && allocationData.additional_attribute_data.length > 0 ? (
                            <table className="table table-hover table-bordered  table-responsive bg-white my-2 ">
                                <tbody>
                                    {allocationData.additional_attribute_data.map((attr) => {
                                        return (<tr key={attr.key}>
                                            <td scope="col" className='text-capitalize' style={{ width: "33%" }}>{attr.name ? attr.name : "-"}</td>
                                            <td scope="col" colSpan={2}>{attr.value_display ? attr.value_display : "-"}</td>
                                        </tr>)
                                    })}
                                </tbody>
                            </table>
                        ) : null}
                        <table className="table table-bordered table-responsive bg-white mt-3">
                            <thead className="table-secondary">
                                <tr>
                                    <th scope="col" style={{ width: "5%" }} className="text-center">
                                        <input type='checkbox' onChange={this.props.checkAllItem} id="all_check_allocation" /></th>
                                    <th scope="col" className="text-center">Item Details</th>
                                    {this.props.isc_configuration?.track_batch_expiry == "Y" ? (
                                        <th scope="col" className="text-center" style={{ width: "18%" }}>Batch Number <br />Expiry Date</th>
                                    ) : null}
                                    <th scope="col" className="text-end" style={{ width: "11%" }}>Qty</th>
                                    <th scope="col" className="text-end" style={{ width: "11%" }}>Invoiced</th>
                                    <th scope="col" className="text-end" style={{ width: "10%" }}>Released</th>
                                    <th scope="col" className="text-end" style={{ width: "10%" }}>Pending</th>
                                </tr>
                            </thead>
                            <tbody>
                                    {
                                    groupedAllocationItems && groupedAllocationItems.length > 0 ? groupedAllocationItems?.map((i, k) => {
                                        return (<tr key={k}>
                                            <td>
                                                {k + 1} <br /><br />
                                                <input
                                                    type='checkbox'
                                                    name="foo"
                                                    value={i.lineItemIds && i.lineItemIds.length > 0 ? i.lineItemIds[0] : i.id}
                                                    data-pendingQty={i.pending_qty}
                                                    className="allocation_item_id_checkbox"
                                                    data-group-key={`group_${k}`}
                                                    onChange={(e) => this.onGroupedItemCheckboxChange(`group_${k}`, e.target.checked)}
                                                    data-warehouseId={allocationData.warehouse_id}
                                                    data-item_profile={i?.item_profile}
                                                    data-transactionId={allocationData.transaction_id}
                                                    data-statusLevel={allocationData.status_data && allocationData.status_data.level}
                                                    data-statusIds={allocationData.status_data && allocationData.status_data.id}
                                                />
                                                {i.lineItemIds && i.lineItemIds.length > 1 ? i.lineItemIds.slice(1).map((lineId) => (
                                                    <input
                                                        key={lineId}
                                                        type='checkbox'
                                                        name="foo"
                                                        value={lineId}
                                                        data-pendingQty={i.pending_qty}
                                                        className="allocation_item_id_checkbox d-none"
                                                        data-group-key={`group_${k}`}
                                                        data-warehouseId={allocationData.warehouse_id}
                                                        data-item_profile={i?.item_profile}
                                                        data-transactionId={allocationData.transaction_id}
                                                        data-statusLevel={allocationData.status_data && allocationData.status_data.level}
                                                        data-statusIds={allocationData.status_data && allocationData.status_data.id}
                                                        readOnly
                                                    />
                                                )) : null}
                                            </td>
                                            <td>{i.item_profile ? <div className='row'>
                                                <div className='col-sm-12'>
                                                    <ItemViewInList item={i.item_profile} remark={i.remark} viewItemModal={() => this.viewItemModalInit(i.item_profile)} />
                                                </div>
                                            </div> : null}</td>
                                            {this.props.isc_configuration?.track_batch_expiry == "Y" ? (
                                                <td>{i.item_profile ? <div>{
                                                    i.selected_batch_list && i.selected_batch_list.length > 0 ? <>
                                                        {i.selected_batch_list.map((b, idx) => this.renderBatchLine(b, idx))}
                                                    </> : "-"
                                                }</div> : "-"}</td>
                                            ) : null}
                                            <td className='text-end'>{i.qty}</td>
                                            <td className='text-end'>{i.invoiced_qty ? i.invoiced_qty : 0}</td>
                                            <td className='text-end'>{i.release_qty ? i.release_qty : 0}</td>
                                            <td className='text-end'>{i.pending_qty ? i.pending_qty : 0}</td>
                                        </tr>)

                                    }) : <tr ><td className='text-center' colSpan={this.props.isc_configuration?.track_batch_expiry == "Y" ? 7 : 6}>No Record</td></tr>
                                }


                            </tbody>
                        </table>
                        <div className="row align-items-center my-2">
                            <div className="col-6">
                                <label htmlFor="notes" className="form-label">Notes</label>
                                <div>{allocationData.notes ? allocationData.notes : "-"}</div>

                            </div>
                            <div className="col-6">
                                <label htmlFor="exampleInputEmail1" className="form-label"><p> &nbsp; </p></label>
                                <table className="table  table-borderless">
                                    <tbody>
                                        <tr className="subtotal_bg_color">
                                            <th>Sub-Total</th>
                                            <td className='float-end'>{allocationData.total_amount ?
                                                <CurrencyFormatter currencyCode={this.props.default_currency} amount={parseFloat(allocationData.total_amount - (allocationData.adjustment_amount)).toFixed(2)} />
                                                : 0}</td>
                                        </tr>
                                        <tr className="subtotal_bg_color">
                                            <th>Adjustment</th>
                                            <td className='float-end'>{allocationData.adjustment_amount ?? 0}</td>
                                        </tr>
                                        <tr className="subtotal_bg_color">
                                            <th>Final Total</th>
                                            <td className='float-end'>{allocationData.total_amount ? <CurrencyFormatter currencyCode={this.props.default_currency} amount={parseFloat(allocationData.total_amount).toFixed(2)} /> : 0}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                    </Ax>
                    : null}
            {this.demandDetailsModalJsx()}
            <ItemDetailsModal ref={this.itemDetailsRef} />

        </Ax>)

    }
}

const mapStateToProps = state => {
    return {
        access_token: state.auth.access_token,
        isc_configuration: state.app && state.app.isc_configuration ? state.app.isc_configuration : null,
        default_currency: state.app && state.app.default_currency ? state.app.default_currency : 'INR',
    };
};

export default connect(mapStateToProps)(SalesAllocationDetail);